import React from "react";
import propTypes from "prop-types";
import { Col, Row } from "reactstrap";
import styled, { css } from "react-emotion";

const GridContainer = styled("div")`
  @media (max-width: 767px) {
    flex-direction: column;
    height: 900px;
    overflow: hidden;
    min-height: 900px;
  }

  @media (min-width: 768px) {
    flex-wrap: wrap
    flex-direction: column;
  }
`;

const dynamicImage = props =>
  css`
    background-image: url(${props.image});
  `;

const GridImage = styled("div")`
  @media (max-width: 767px) {
    ${dynamicImage};
    height: 200px;
    max-height: 200px;
    width: 100%;
    overflow: hidden;
    max-width: 100%;
    background-size: cover;
  }

  @media (min-width: 768px) {
    ${dynamicImage};
    height: 200px;
    max-height: 200px;
    overflow: hidden;
    background-size: cover;
    min-width: 33%;
  }
`;


export default class Grid9Img extends React.Component {
  constructor(props) {
    super(props);
    const settings = {
      fade: true,
      autoplay: true,
      speed: 1000,
      arrows: false
    };

    this.colors =  {
      primary: '#0055a4',
      secondary: '#8ca2d4',
      tertiary: '#bcc5e6',
      primaryDark: '#565656',
      secondaryDark: '#6a6a6a',
      tertiaryDark: '#727272',
      fontColor: '#ffffff',
      fontColorDark: '#e56026'
    }
  }

  render() {
    let primary = this.colors.primary;
    let secondary = this.colors.secondary;
    let tertiary = this.colors.tertiary;
    let fontColor = this.colors.fontColor;

    if (this.props.theme === 'dark') {
      primary = this.colors.primaryDark;
      secondary = this.colors.secondaryDark;
      tertiary = this.colors.tertiaryDark;
      fontColor = this.colors.fontColorDark;
    } 
    return (
      <Row>
        <Col md="12">
          <GridContainer className="d-flex flex-wrap">
            <GridImage image={this.props.image1.image} />
            <GridImage image={this.props.image2.image} />
            <GridImage image={this.props.image3.image} />
            <GridImage image={this.props.image4.image} />
            <GridImage image={this.props.image5.image} />
            <GridImage image={this.props.image6.image} />
            <GridImage image={this.props.image7.image} />
            <GridImage image={this.props.image8.image} />
            <GridImage image={this.props.image9.image} />
          </GridContainer>
        </Col>
      </Row>
    );
  }
}

Grid9Img.propTypes = {
  image1: propTypes.object.isRequired,
  image2: propTypes.object.isRequired,
  image3: propTypes.object.isRequired,
  image4: propTypes.object.isRequired,
  image5: propTypes.object.isRequired,
  image6: propTypes.object.isRequired,
  image7: propTypes.object.isRequired,
  image8: propTypes.object.isRequired,
  image9: propTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Grid9Img.js